function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-dupe-class-members */
import { scaleOrdinal } from 'd3-scale';
import ExtensibleFunction from '../models/ExtensibleFunction';
import stringifyAndTrim from '../utils/stringifyAndTrim'; // Use type augmentation to correct the fact that
// an instance of CategoricalScale is also a function

class ScaleCategoricalColor extends ExtensibleFunction {
  /**
   * Constructor
   * @param {*} colors an array of colors
   * @param {*} parentmanualColors optional parameter that comes from parent
   * (usually CategoricalColorNamespace) and supersede this.manualColors
   */
  constructor(stateOrColors, parentmanualColors) {
    super(value => this.getColor(value));

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "parentManualColors", void 0);

    if (Array.isArray(stateOrColors)) {
      this.state = {
        manualColors: {},
        scale: scaleOrdinal(stateOrColors)
      };
    } else {
      this.state = stateOrColors;
    }

    this.parentManualColors = parentmanualColors;
  }

  get colors() {
    return this.state.scale.range();
  }

  getColor(value) {
    const cleanedValue = stringifyAndTrim(value);
    const parentColor = this.parentManualColors && this.parentManualColors[cleanedValue];

    if (parentColor) {
      return parentColor;
    }

    const manualColor = this.state.manualColors[cleanedValue];

    if (manualColor) {
      return manualColor;
    }

    return this.state.scale(cleanedValue);
  }
  /**
   * Enforce specific color for given value
   * @param {*} value value
   * @param {*} manualColor manualColor
   */


  setColor(value, manualColor) {
    this.state.manualColors[stringifyAndTrim(value)] = manualColor;
    return this;
  }
  /**
   * Get a mapping of data values to colors
   * @returns an object where the key is the data value and the value is the hex color code
   */


  getColorMap() {
    const colorMap = {};
    this.state.scale.domain().forEach(value => {
      colorMap[String(value)] = this.state.scale(value);
    });
    return { ...colorMap,
      ...this.state.manualColors,
      ...this.parentManualColors
    };
  }
  /**
   * Returns an exact copy of this scale. Changes to this scale will not affect the returned scale, and vice versa.
   */


  copy() {
    const copy = new ScaleCategoricalColor({
      manualColors: { ...this.state.manualColors
      },
      scale: this.state.scale.copy()
    }, this.parentManualColors);
    return copy;
  }
  /**
   * Returns the scale's current domain.
   */


  domain(newDomain) {
    if (typeof newDomain === 'undefined') {
      return this.state.scale.domain();
    }

    this.state.scale.domain(newDomain);
    return this;
  }
  /**
   * Returns the scale's current range.
   */


  range(newRange) {
    if (typeof newRange === 'undefined') {
      return this.state.scale.range();
    }

    this.state.scale.range(newRange);
    return this;
  }
  /**
   * Returns the current unknown value, which defaults to "implicit".
   */


  unknown(value) {
    if (typeof value === 'undefined') {
      return this.state.scale.unknown();
    }

    this.state.scale.unknown(value);
    return this;
  }

}

export default ScaleCategoricalColor;